import { z } from 'zod';

export const PaginationMetaSchema = z.object({
  last: z.number(),
  next: z.number().nullable(),
  page: z.number(),
  prev: z.number().nullable(),
  size: z.number(),
  total: z.number(),
  count: z.any(),
});
